export default __webpack_public_path__ + "static/media/dropbox.d87a1c75.svg";